import { render, staticRenderFns } from "./InvestorBeneficiariesData.vue?vue&type=template&id=aa7f35de&"
import script from "./InvestorBeneficiariesData.vue?vue&type=script&lang=js&"
export * from "./InvestorBeneficiariesData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports